import { render, staticRenderFns } from "./manageOpen.vue?vue&type=template&id=0a38de90&scoped=true&"
import script from "./manageOpen.vue?vue&type=script&lang=js&"
export * from "./manageOpen.vue?vue&type=script&lang=js&"
import style0 from "./manageOpen.vue?vue&type=style&index=0&id=0a38de90&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a38de90",
  null
  
)

export default component.exports